import { cloudDB, rtdb } from '../../server/index'

export const writeProductData = async (user, table, storeID, products) => {
    try {
        const updateProducts = products.map((product) => {
            Object.keys(product).forEach(key => product[key] === undefined ? delete product[key] : {});
            return product;
        });
        await rtdb.ref(`SharedCart/${storeID}/${table}/${user}`).update({ products: updateProducts });
        const unixTimestamp = Math.floor(Date.now() / 1000);
        await rtdb.ref(`SharedCart/${storeID}/${table}`).update({ LastUpdated: unixTimestamp });
        return true;
    } catch (error) {
       return false;
    }
}

export const readProductData = async (table, storeID) => {
    try {
        const dbRef = rtdb.ref();
        const snapshot = await dbRef.child(`SharedCart/${storeID}/${table}`).once('value');
        if (snapshot.exists) {
            return snapshot.val();
        }
        return {};
    } catch (error) {
        return {};
    }
}

export const getDbRef = (storeID, table) => {
    return rtdb.ref(`SharedCart/${storeID}/${table}`);
}

export const removeUser = async (user, storeID, table) => {
    try {
        await rtdb.ref(`SharedCart/${storeID}/${table}/${user}`).remove();
        return {
            success: true
        };
    } catch (error) {
        return {
            success: false,
            error
        };
    }
}

export const removeOrder = async (storeID, table) => {
    try {
        await rtdb.ref(`SharedCart/${storeID}/${table}`).remove();
        return {
            success: true
        };
    } catch (error) {
        return {
            success: false,
            error
        };
    }
}

export const updateOrderStatus = async (table, storeID, status) => {
    try {
        await rtdb.ref(`SharedCart/${storeID}/${table}`).update(status);
        return true;
    } catch (error) {
       return false;
    }
}

export const getOrderSummary = async (storeID, table) => {
    const result = {
        data: {},
        error: 'Order not found'
    };
    try {
        const orderRef = cloudDB.ref(`OrdersSummary/${storeID}`);
        const snapshot = await orderRef.get();
        if (snapshot.exists()) {
            const keys = Object.keys(snapshot.val());
            const orderTypeString = `Table: ${table}`;
            const orderSummary = keys.filter((key) => {
                const order = snapshot.val()[key];
                if (order.OrderTypeString === orderTypeString && order.Status === 2) {
                  return order;
                }
                return false;
              });
              if (orderSummary.length > 0) {
                const summary = snapshot.val()[orderSummary[0]];
                result.error = '';
                result.data = summary;
              } 
        }
    } catch (error) {
        result.error = error.message || 'Something went wrong, Please try again';
    }
    return result;
}

export const getOrder = async (storeID, orderID) => {
    const result = {
        data: {},
        error: '',
    };
    try {
        const orderRef = cloudDB.ref(`Orders/${storeID}/${orderID}`);
        const snapshot = await orderRef.get();
        if (snapshot.exists()) {
            result.data = snapshot.val();
        }
    } catch (error) {
        result.error = error.message || 'Something went wrong, Please try again';
    }
    return result;
};

export const listenOrder = (storeID, orderID) => { 
    return cloudDB.ref(`Orders/${storeID}/${orderID}`);
}

export const getDeviceUDID = async (storeID) => {
    const data = {
        deviceID: '',
        error: 'POS is not online',
    };
    try {
        const deviceRef = rtdb.ref(`Devices/${storeID}/DeviceMode`)
        const snapshot = await deviceRef.get();
        if (snapshot.exists()) {
            const keys = Object.keys(snapshot.val());
            let timestamp = 0;
            keys.forEach((key) => {
                const device = snapshot.val()[key];
                if (
                device.DeviceMode === 'Master POS' &&
                device.Timestamp > timestamp
                ) {
                    timestamp = device.Timestamp;
                    data.deviceID = key;
                }
            });
            if (new Date().getTime() - timestamp < 180000) data.error = '';
        }
    } catch (error) {
        console.log('error', error);
        data.error = "Something went wrong! Please try again";
    }
    return data;
}

export const writeMessageQueue = async(
    storeID,
    deviceID,
    fromDeviceUUID,
    message,
    status,
    messageType,
    transactionID,
    timestamp
) => {
    const data = {
        success: false,
        error: 'Something went wrong',
    };
    try {
        const dbRef = rtdb.ref(`/Devices/${storeID}/MessageQueue/${deviceID}/${transactionID}`)
        await dbRef.set({
            FromDeviceUUID: fromDeviceUUID,
            Message: message,
            Status: status,
            MessageType: messageType,
            TransactionID: transactionID,
            Timestamp: timestamp,
        })
        data.success = true;
        data.error = '';
    } catch (error) {
        console.log('error', error);
        data.error = "Something went wrong! Please try again";
    }
    return data;
}